import { all, put, takeEvery, select } from "redux-saga/effects";
import {
  CONFIRM_CANCEL_EXAM,
  CONFIRM_CANCEL_EXAM_FAILURE,
  CONFIRM_CANCEL_EXAM_SUCESS,
  ConfirmCancelExamAction,
  MARK_EXAM_REDO,
  MARK_EXAM_REDO_FAILURE,
  MARK_EXAM_REDO_SUCCESS,
  MarkExamRedoAction,
  updatePublicAnalysisRequest,
} from "../actions/analysis-request";
import { selectAnalysisRequestIndexedObjects, selectAnalysisRequestObjects } from "../selectors/analysis-request";
import { addNotification } from "../actions/notification";
import { NOTIFICATION_STATUS_ERROR, NOTIFICATION_STATUS_SUCCESS } from "../types/Notification";
import { AnalysisRequestState } from "../types/shared/v2/AnalysisRequest";
import { matchRef } from "../util/analysis-request";

export function* analysisRequestSaga(): Generator<any, any, any> {
  yield all([
    takeEvery(CONFIRM_CANCEL_EXAM, cancelExamsSaga),
    takeEvery(MARK_EXAM_REDO, markExamRedoSaga),
  ]);
}

// Ticket #821 - Remise « à refaire » d'un examen intégré à une liste de
// travail exportée : l'examen passe au stade 7 et réintègre le pot commun des
// examens sélectionnables pour une nouvelle liste.
export function* markExamRedoSaga(
  action: MarkExamRedoAction
): Generator<any, any, any> {
  try {
    const analysisRequestObjects = yield select(selectAnalysisRequestObjects);
    const analysisRequest = analysisRequestObjects.find((obj) =>
      matchRef(obj.data, action.analysisRequestRef)
    );
    if (!analysisRequest) {
      throw new Error(
        `Demande d'analyse '${action.analysisRequestRef.requestorSampleId}' introuvable !`
      );
    }

    analysisRequest.data.types[action.analysisRequestCode] = AnalysisRequestState.RedoRequested;

    yield put(updatePublicAnalysisRequest(analysisRequest.id, analysisRequest.data));
    yield put(
      addNotification({
        message: `Examen ${action.analysisRequestCode} du prélèvement ${analysisRequest.data.requestorSampleId} remis à refaire.`,
        status: NOTIFICATION_STATUS_SUCCESS,
      })
    );
  } catch (err) {
    yield put(
      addNotification({
        message: `La remise à refaire de l'examen ${action.analysisRequestCode} a échoué.`,
        status: NOTIFICATION_STATUS_ERROR,
      })
    );
    yield put({ type: MARK_EXAM_REDO_FAILURE, err });
    return;
  }
  yield put({ type: MARK_EXAM_REDO_SUCCESS });
}

export function* cancelExamsSaga(
  action: ConfirmCancelExamAction
): Generator<any, any, any> {
  try {
    const analysisRequestObjects = yield select(selectAnalysisRequestIndexedObjects);
    const cancelExams = action.cancelExams;
    const cancelExamKeys = Object.keys(cancelExams);
    for (const cancelExamKey of cancelExamKeys) {
      const typesToDelete = cancelExams[cancelExamKey].type;
      for (const type of typesToDelete) {
        delete analysisRequestObjects[cancelExamKey].data.types[type];
        yield put(
          updatePublicAnalysisRequest(
            analysisRequestObjects[cancelExamKey].id,
            analysisRequestObjects[cancelExamKey].data
          )
        );
        yield put(
          addNotification({
            message: `Examen ${type} pour le numéro de prélèvement ${analysisRequestObjects[cancelExamKey].data.requestorSampleId} supprimés.`,
            status: NOTIFICATION_STATUS_SUCCESS,
          })
        );
      }
    }
  } catch (err) {
    yield put({ type: CONFIRM_CANCEL_EXAM_FAILURE, err });
    return;
  }
  yield put({ type: CONFIRM_CANCEL_EXAM_SUCESS });
}
